import { render, staticRenderFns } from "./CustomerFeedbackPage.vue?vue&type=template&id=c981b9b2&"
import script from "./CustomerFeedbackPage.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports